import React, { useEffect, useState } from 'react'
import Logo from '../assets/logo.png'
import { User, Play, Heart, ArrowLeft } from 'lucide-react';
import Slider from "react-slick";
import { useLocation } from 'react-router-dom';


export default function Header({ categories }) {

  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(false);
  const [isMobile, setIsMobile] = useState(false);      // State to track if it's a mobile screen


  useEffect(() => {
    if (location.pathname == ('/home')) {
      setIsHomePage(true);
    } else {
      setIsHomePage(false);
    }


    // Function to detect mobile screen size
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true);  // If width is less than or equal to 768px, set as mobile
      } else {
        setIsMobile(false); // Otherwise, it's not mobile
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  var settings = {
    arrows: false,
    dots: false,
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 3,
    gap: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };




  return (
    <>
      {isMobile ? (
        <div className='container'>
          {window.location.pathname != '/home' && (
            <ArrowLeft
              size={'30px'}
              color='white'
              onClick={() => window.history.back()}
              style={{ cursor: 'pointer' }}
            />
          )}
          <img
            width={70}
            src={Logo}
            onClick={() => (window.location.href = '/home')}
            style={{ cursor: 'pointer' }}
          />
        </div>
      ) : (
        <div style={{ marginBottom: '10rem' }}>
          <div className='header_2 d-flex flex-column'>
            <div className='container d-flex flex-row justify-content-between align-items-center'>
              <img
                width={90}
                src={Logo}
                onClick={() => (window.location.href = '/home')}
                style={{ cursor: 'pointer' }}
              />
              <div className='d-flex gap-2 align-items-center'>
                <button
                  className='btn btn-primary'
                  onClick={() => (window.location.href = '/favorites')}
                >
                  Favorites <Heart />
                </button>
                <User color='pink' onClick={() => (window.location.href = '/profile')} />
              </div>
            </div>

            {isHomePage && (
              <div className='container'>
                <div className='header-swiper'>
                  <Slider {...settings}>
                    {categories.map((cat, VidIndex) => (
                      <div key={VidIndex}>
                        <div
                          className='header_category'
                          onClick={() => (window.location.href = `#category_${cat.Name}`)}
                        >
                          <p className='m-0'>{cat.Name}</p>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
